import type {Editor} from 'grapesjs';
import type {EmailMakerColorPickerTarget} from '@EmailMakerReact/email-maker-react.types';

export interface ColorPickerViewProps {
  editor: Editor;
  target: EmailMakerColorPickerTarget;
  onBack: () => void;
  /** When set, the header shows a close (X) alongside back — used by the mobile sheet to dismiss the whole control flow. */
  onClose?: () => void;
}

export const COLOR_PICKER_ID = 'email-maker-color-picker';
